import { Occupant, Person } from '../models/license';

export const addDisplayName = (people: Person[] | Occupant[]) => {
  return people.map(person => ({
    ...person,
    displayName: person.firstName ? person.firstName + ' ' + person.lastName : '',
  }));
};
